// reducers/dealPaymentReducer.js

const initialState = {
  dealBoughtData: [],
};

const dealPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_DEAL_BOUGHT_DATA":
      return {
        ...state,
        dealBoughtData: action.payload,
      };
    default:
      return state;
  }
};

export default dealPaymentReducer;

const genRec = {
  generalReceiptData: [],
};

export const generalReceiptReducer = (state = genRec, action) => {
  switch (action.type) {
    case "SET_GENERAL_RECEIPT_DATA":
      return {
        ...state,
        generalReceiptData: action.payload,
      };
    default:
      return state;
  }
};

// reducers/unitReceiptPrintReducer.js

const unitReceipt = {
  unitReceiptPrintData: null,
};

export const unitReceiptPrintReducer = (state = unitReceipt, action) => {
  switch (action.type) {
    case "SET_UNIT_RECEIPT_PRINT_DATA":
      return {
        ...state,
        unitReceiptPrintData: action.payload,
      };
    default:
      return state;
  }
};

const pdcRec = {
  pdcReceiptData: [],
  cache: {},
};

export const pdcReceiptReducer = (state = pdcRec, action) => {
  switch (action.type) {
    case "SET_PDC_RECEIPT_DATA":
      return {
        ...state,
        pdcReceiptData: action.payload,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };
    case "CLEAR_PDC_RECEIVABLE_CACHE":
      return {
        ...state,
        cache: {},
      };
    default:
      return state;
  }
};

// -------------------- PDC Payables -------------------- //
const pdcPay = {
  pdcPayableData: [],
  cache: {},
};

export const pdcPayableReducer = (state = pdcPay, action) => {
  switch (action.type) {
    case "SET_PDC_PAYABLE_DATA":
      return {
        ...state,
        pdcPayableData: action.payload,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };
    case "CLEAR_PDC_PAYABLE_CACHE":
      return {
        ...state,
        cache: {},
      };
    default:
      return state;
  }
};
